import { render, staticRenderFns } from "./denied.vue?vue&type=template&id=3a28861b&"
import script from "./denied.vue?vue&type=script&lang=js&"
export * from "./denied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports